module.exports = __webpack_public_path__ + "img/customization_nav.bfda7dad.png";